module.exports = __webpack_public_path__ + "img/ico_effect_high_energy.f9eda88a.svg";